"use strict";
/**
 * @file Created on Wed Aug 12 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Tomas Leity
 */


var DummyWindowSimulationParams =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(DummyWindowSimulationParams, _DomainObject_1$Domai);

  /**
   * @param dummyId
   * @param windowName
   * @param productId
   * @param productName
   * @param promoVolume
   * @param promoPrice
   * @param promoPurchasePrice
   */
  function DummyWindowSimulationParams(dummyId, windowName, productId, productName, promoVolume, promoPrice, promoPurchasePrice) {
    var _this;

    _classCallCheck(this, DummyWindowSimulationParams);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DummyWindowSimulationParams).call(this));
    _this.dummyId = dummyId;
    _this.windowName = windowName;
    _this.productId = productId;
    _this.productName = productName;
    _this.promoVolume = promoVolume;
    _this.promoPrice = promoPrice;
    _this.promoPurchasePrice = promoPurchasePrice;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(DummyWindowSimulationParams, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new DummyWindowSimulationParams(mat.dummyId, mat.windowName, mat.productId, mat.productName, mat.promoVolume, mat.promoPrice, mat.promoPurchasePrice);
    }
  }]);

  return DummyWindowSimulationParams;
}(DomainObject_1.DomainObject);

exports.DummyWindowSimulationParams = DummyWindowSimulationParams;
DummyWindowSimulationParams.DOCUMENT_TYPE = DummyWindowSimulationParams.name;

DummyWindowSimulationParams.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(DummyWindowSimulationParams.name);
  return {
    dummyId: builder.str('dummyId'),
    windowName: builder.str('windowName'),
    productId: builder.str('productId'),
    productName: builder.str('productName'),
    promoVolume: builder.bigNum('promoVolume'),
    promoPrice: builder.bigNum('promoPrice'),
    promoPurchasePrice: builder.bigNum('promoPurchasePrice')
  };
}();